<template>
  <div class="uk-section">
    <div class="uk-container">
      <div class="uk-width-1-2 uk-width-1-3@m uk-margin-auto">
        <div class="uk-card uk-card-default uk-card-body">
            <h2>Acceso</h2>
          <form @submit.prevent="login">
            <fieldset class="uk-fieldset">
              <label for="exampleInputEmail1">Email</label>
              <div class="uk-margin">
                <input
                  type="email"
                  class="uk-input"
                  placeholder="Ingrese su email"
                  v-model="email"
                />
              </div>
              <label for="exampleInputPassword1">Password</label>

              <div class="uk-margin">
                <input
                  type="password"
                  class="uk-input"
                  placeholder="Password"
                  v-model="password"
                />
              </div>
              <button class="uk-button uk-button-primary">Ingresar</button>
            </fieldset>
            <p class="uk-text-center">No tiene cuenta, <router-link to="/register">Registrarse</router-link></p>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { useRouter, useRoute } from 'vue-router';

export default {
    // name: "Login",
    // data() {
    //     return {
    //         email: "",
    //         password: ""
    //     };
    // },
    // methods: {
    //     login() {
    //         const auth = getAuth();
    //         signInWithEmailAndPassword(auth, this.email, this.password)
    //             .then(() => {
    //                 console.log('logeado');
    //                 this.$router.push("/");
    //             })
    //             .catch(error => {
    //                 console.log(error);
    //                 alert(error.message);
    //             });
    //     }
    // },
    // mounted() {
    //     const auth = getAuth();
    //     onAuthStateChanged(auth, (user) => {
    //         if (user) {
    //             console.log(user);
    //             this.$router.push("/");
    //         }else{
    //             console.log('no user');
    //         }
    //     });
    // }

    setup() {
        // const route = useRoute();
        // const router = useRouter();
        const email = ref('');
        const password = ref('');
        // const error = ref('');
        // const loading = ref(false);
        // const user = ref(null);

        // onBeforeMount(() => {
        //     const auth = getAuth();
        //     onAuthStateChanged( auth, (user) => {
        //         if (!user) {
        //             router.replace("/login");
        //         } else if (route.path === "/login" || route.path === "/register") {
        //             router.replace("/");
        //         }
        //     });
        // });

        const login = () => {
            const auth = getAuth();
            signInWithEmailAndPassword(auth, email.value, password.value)
                .then(() => {
                    console.log('logeado');
                    // this.$router.push("/");
                    //router.replace("/");
                    email.value = '';
                    password .value = '';
                })
                .catch(error => {
                    //console.log(error);
                    email.value = '';
                    password .value = '';
                    alert('Oh no!!, Parece que no estas registrado.');

                    // error.value = error.message;
                    // loading.value = false;
                });
        };

        return {
            email,
            password,
            login
        };
    }
};
</script>

<style></style>
